
export default {
  name: "cal-v-feature-section",
  props: ["featureBlocks"],
};
